(() => {
  if (window.FadropWishlist) {
    window.FadropWishlist.init();
    return;
  }

  const STORAGE_KEY = "fadrop:wishlist:v1";
  const PENDING_STORAGE_KEY = "fadrop:wishlist:pending:v1";
  const VIEW_STORAGE_KEY = "fadrop:wishlist:view";
  const WISHLIST_URL = "/pages/wishlist";
  const PENDING_MAX_AGE_MS = 2 * 60 * 60 * 1000;
  let dynamicButtonObserver = null;

  const escapeHtml = (value) => String(value || "").replace(/[&<>"']/g, (char) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  }[char]));

  const stripHtml = (value) => {
    const element = document.createElement("div");
    element.innerHTML = String(value || "");
    return element.textContent.trim();
  };

  const cleanPrice = (value) => {
    let text = stripHtml(value).replace(/\s+/g, " ").trim();
    if (/<[^>]+>/.test(text)) {
      text = stripHtml(text).replace(/\s+/g, " ").trim();
    }

    const currencyFirst = text.match(/^([A-Z]{3})\s+([0-9][0-9.,]*)$/);
    if (currencyFirst) {
      return currencyFirst[2] + " " + currencyFirst[1];
    }

    return text;
  };

  const splitColors = (value) => {
    if (Array.isArray(value)) return value.map((color) => String(color || "").trim()).filter(Boolean);
    return String(value || "").split("||").map((color) => color.trim()).filter(Boolean);
  };

  const productColors = (product) => {
    const options = Array.isArray(product?.options) ? product.options : [];
    const colorIndex = options.findIndex((option) => /colou?r/i.test(String(option?.name || option || "")));
    if (colorIndex < 0 || !Array.isArray(product?.variants)) return [];

    const colors = product.variants
      .map((variant) => Array.isArray(variant.options) ? variant.options[colorIndex] : variant["option" + (colorIndex + 1)])
      .filter(Boolean);

    return [...new Set(colors.map((color) => String(color).trim()).filter(Boolean))];
  };

  const SWATCH_COLORS = {
    black: "#000000",
    "washed black": "#2f2f2f",
    white: "#ffffff",
    cream: "#f2efdc",
    beige: "#ece5d1",
    ivory: "#f6f1df",
    grey: "#7a7a7a",
    gray: "#7a7a7a",
    charcoal: "#333333",
    navy: "#101a33",
    blue: "#1f5fbf",
    red: "#c6252a",
    green: "#2f7d46",
    brown: "#7a4b2b",
    pink: "#ef9eb5",
    purple: "#6d4bb8",
    yellow: "#f1d64b",
    orange: "#e97825",
    "retro purple": "#c0aed8",
    "retro rose red": "#d8768f",
    "retro wash pink": "#eaa9bd",
    "mist blue": "#5a6884",
    "retro dark gray": "#747474",
    "retro dark grey": "#747474",
    "retro light gray": "#b7b8b8",
    "retro light grey": "#b7b8b8",
    "retro army green": "#949887",
    "vintage khaki": "#ab9d85",
  };

  const swatchColor = (name) => {
    const normalized = String(name || "").trim().toLowerCase();
    return SWATCH_COLORS[normalized] || SWATCH_COLORS[normalized.split(/\s+/)[0]] || "#f2f2f2";
  };

  const swatchesMarkup = (colors) => {
    const allValues = splitColors(colors);
    const values = allValues.slice(0, 3);
    const remaining = Math.max(allValues.length - values.length, 0);
    if (!values.length) return "";

    return '<div class="fadrop-wishlist-card__swatches" aria-label="Available colors">' + values.map((color) => {
      const label = escapeHtml(color);
      return '<span class="fadrop-wishlist-card__swatch" title="' + label + '" aria-label="' + label + '" style="--fadrop-swatch: ' + swatchColor(color) + '"></span>';
    }).join("") + (remaining > 0 ? '<span class="fadrop-wishlist-card__swatch-more" aria-label="' + remaining + ' more colors" style="display:inline-flex;align-items:center;height:18px;margin-left:4px;font-size:11px;font-weight:700;color:#6b7280;line-height:1;white-space:nowrap;">+ ' + remaining + ' colors</span>' : '') + "</div>";
  };

  const escapeSelector = (value) => {
    if (window.CSS?.escape) return CSS.escape(String(value || ""));
    return String(value || "").replace(/["\\]/g, "\\$&");
  };

  const selectedVariantId = (button) => {
    const form = button.closest("form");
    const variantInput = form?.querySelector('[name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    return String(variantInput?.value || "").trim();
  };

  const findVariant = (product, variantId) => {
    if (!variantId || !Array.isArray(product?.variants)) return null;
    return product.variants.find((variant) => String(variant.id) === String(variantId)) || null;
  };

  const variantImage = (variant) => variant?.featured_image?.src || variant?.featured_media?.preview_image?.src || "";

  const loginUrl = (source) => {
    const configured = source?.dataset?.loginUrl;
    if (configured) return configured;
    return "/account/login?return_url=" + encodeURIComponent(window.location.pathname + window.location.search);
  };

  const signedIn = (source) => source?.dataset?.customerSignedIn === "true";

  const pendingFresh = (item) => {
    const savedAt = Date.parse(item?.savedAt || "");
    return savedAt && Date.now() - savedAt < PENDING_MAX_AGE_MS;
  };

  const readPending = () => {
    try {
      const item = JSON.parse(localStorage.getItem(PENDING_STORAGE_KEY) || "null");
      return item && item.handle && pendingFresh(item) ? item : null;
    } catch {
      return null;
    }
  };

  const writePending = (item) => {
    if (!item?.handle) return;

    try {
      localStorage.setItem(PENDING_STORAGE_KEY, JSON.stringify({
        ...item,
        savedAt: new Date().toISOString(),
      }));
    } catch {
      // If storage is blocked, login still works; only the automatic favourite add is skipped.
    }
  };

  const clearPending = () => {
    try {
      localStorage.removeItem(PENDING_STORAGE_KEY);
    } catch {
      // Ignore storage errors.
    }
  };

  const redirectToLogin = (source) => {
    const item = source?.matches?.("[data-fadrop-wishlist-button]") ? buttonItem(source) : null;
    if (item?.handle) writePending(item);
    window.location.href = loginUrl(source);
  };

  const read = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map((item) => (typeof item === "string" ? { handle: item } : item))
        .filter((item) => item && item.handle)
        .map((item) => ({ ...item, price: cleanPrice(item.price), colors: splitColors(item.colors) }));
    } catch {
      return [];
    }
  };

  const write = (items) => {
    const unique = [];
    const seen = new Set();

    items.forEach((item) => {
      const handle = String(item.handle || "").trim();
      if (!handle || seen.has(handle)) return;
      seen.add(handle);
      unique.push({ ...item, handle, price: cleanPrice(item.price), colors: splitColors(item.colors) });
    });

    localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
    window.dispatchEvent(new CustomEvent("fadrop:wishlist:change"));
  };

  const has = (handle) => read().some((item) => item.handle === handle);

  const save = (item) => {
    write([item, ...read().filter((existing) => existing.handle !== item.handle)]);
  };

  const remove = (handle) => {
    write(read().filter((item) => item.handle !== handle));
  };

  const readView = () => localStorage.getItem(VIEW_STORAGE_KEY) === "list" ? "list" : "grid";

  const setView = (root, view) => {
    const nextView = view === "list" ? "list" : "grid";
    localStorage.setItem(VIEW_STORAGE_KEY, nextView);
    root.classList.toggle("is-list-view", nextView === "list");
    root.classList.toggle("is-grid-view", nextView !== "list");
    root.querySelectorAll("[data-fadrop-wishlist-view]").forEach((button) => {
      const active = button.dataset.fadropWishlistView === nextView;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  };

  const buttonItem = (button) => ({
    handle: button.dataset.productHandle,
    title: button.dataset.productTitle,
    url: button.dataset.productUrl || "/products/" + button.dataset.productHandle,
    image: button.dataset.productImage,
    variantId: selectedVariantId(button),
    currency: button.dataset.productCurrency || "AED",
    colors: splitColors(button.dataset.productColors),
    price: Number.isFinite(Number(button.dataset.productPriceCents)) && button.dataset.productPriceCents
      ? formatMoney(Number(button.dataset.productPriceCents), button.dataset.productCurrency || "AED", button.dataset.productPrice)
      : cleanPrice(button.dataset.productPrice),
    addedAt: new Date().toISOString(),
  });

  const syncButton = (button) => {
    const active = has(button.dataset.productHandle);
    const label = button.querySelector("[data-fadrop-wishlist-label]");

    button.classList.toggle("is-active", active);
    button.setAttribute("aria-pressed", active ? "true" : "false");
    if (label) {
      label.textContent = active ? "Added to favourites" : "Add to favourite";
    }
  };

  const bindButtons = () => {
    document.querySelectorAll("[data-fadrop-wishlist-button]").forEach((button) => {
      if (!button.dataset.fadropWishlistBound) {
        button.dataset.fadropWishlistBound = "true";
        button.addEventListener("click", async () => {
          if (!signedIn(button)) {
            redirectToLogin(button);
            return;
          }

          let item = buttonItem(button);
          if (!item.handle) return;
          item = await fetchProduct(item, item.currency);

          if (has(item.handle)) {
            remove(item.handle);
          } else {
            save(item);
            showModal(item);
          }

          syncAllButtons();
          renderPage();
        });
      }

      syncButton(button);
    });
  };

  const consumePending = async () => {
    const pending = readPending();
    if (!pending?.handle) return;

    const signedInSource = document.querySelector('[data-fadrop-wishlist-button][data-customer-signed-in="true"], [data-fadrop-wishlist-page][data-customer-signed-in="true"]');
    if (!signedInSource) return;

    const matchingButton = document.querySelector('[data-fadrop-wishlist-button][data-product-handle="' + escapeSelector(pending.handle) + '"]');
    let item = matchingButton ? buttonItem(matchingButton) : pending;
    item = await fetchProduct(item, item.currency);

    clearPending();

    if (!has(item.handle)) {
      save(item);
      if (matchingButton) {
        showModal(item);
      }
    }

    syncAllButtons();
    renderPage();
  };

  const syncAllButtons = () => {
    document.querySelectorAll("[data-fadrop-wishlist-button]").forEach(syncButton);
  };

  const formatMoney = (cents, currency, fallback) => {
    if (typeof cents !== "number") return cleanPrice(fallback);
    const code = currency || "AED";
    return (cents / 100).toFixed(2) + " " + code;
  };

  const fetchProduct = async (item, currency) => {
    try {
      const response = await fetch("/products/" + encodeURIComponent(item.handle) + ".js", {
        headers: { Accept: "application/json" },
      });
      if (!response.ok) return item;
      const product = await response.json();
      const variant = findVariant(product, item.variantId);
      return {
        ...item,
        title: product.title || item.title,
        url: product.url || "/products/" + item.handle,
        image: variantImage(variant) || item.image || product.featured_image || product.images?.[0],
        price: formatMoney(variant?.price ?? product.price, currency || item.currency, item.price),
        colors: splitColors(item.colors).length ? splitColors(item.colors) : productColors(product),
      };
    } catch {
      return item;
    }
  };

  const trashIcon = () => [
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none">',
    '<path d="M4 7h16"/>',
    '<path d="M10 11v6"/>',
    '<path d="M14 11v6"/>',
    '<path d="M6 7l1 14h10l1-14"/>',
    '<path d="M9 7V4h6v3"/>',
    "</svg>",
  ].join("");

  const cardMarkup = (item) => {
    const title = escapeHtml(item.title || "Product");
    const url = escapeHtml(item.url || "/products/" + item.handle);
    const image = escapeHtml(item.image || "");
    const price = escapeHtml(cleanPrice(item.price));
    const swatches = swatchesMarkup(item.colors);
    const handle = escapeHtml(item.handle);

    return [
      '<article class="fadrop-wishlist-card" data-fadrop-wishlist-card="' + handle + '">',
      '<a class="fadrop-wishlist-card__image-link" href="' + url + '" aria-label="' + title + '">',
      image ? '<img class="fadrop-wishlist-card__image" src="' + image + '" alt="' + title + '" loading="lazy">' : "",
      "</a>",
      '<h2 class="fadrop-wishlist-card__title"><a href="' + url + '">' + title + "</a></h2>",
      price ? '<p class="fadrop-wishlist-card__price">' + price + "</p>" : "",
      swatches,
      '<div class="fadrop-wishlist-card__actions">',
      '<a class="fadrop-wishlist-card__view" href="' + url + '">View product</a>',
      '<button class="fadrop-wishlist-card__remove" type="button" data-fadrop-wishlist-remove="' + handle + '" aria-label="Remove from favourites">' + trashIcon() + "</button>",
      "</div>",
      "</article>",
    ].join("");
  };

  const modalMarkup = (item) => {
    const title = escapeHtml(item.title || "Product");
    const image = escapeHtml(item.image || "");
    const price = escapeHtml(cleanPrice(item.price));

    return [
      '<button class="fadrop-wishlist-modal__overlay" type="button" data-fadrop-wishlist-close aria-label="Close wishlist modal"></button>',
      '<aside class="fadrop-wishlist-modal__panel" role="dialog" aria-modal="true" aria-label="Favorites">',
      '<button class="fadrop-wishlist-modal__close" type="button" data-fadrop-wishlist-close aria-label="Close"><svg viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6 6 18"/></svg></button>',
      '<h2 class="fadrop-wishlist-modal__title"><span class="fadrop-wishlist-modal__check"><svg viewBox="0 0 24 24" fill="none"><path d="m6 12 4 4 8-8"/></svg></span>Favorites</h2>',
      '<div class="fadrop-wishlist-modal__item">',
      image ? '<img class="fadrop-wishlist-modal__image" src="' + image + '" alt="' + title + '">' : '<span class="fadrop-wishlist-modal__image"></span>',
      '<div><h3 class="fadrop-wishlist-modal__name">' + title + '</h3>' + (price ? '<p class="fadrop-wishlist-modal__price">' + price + "</p>" : "") + "</div>",
      "</div>",
      '<a class="fadrop-wishlist-modal__view" href="' + WISHLIST_URL + '">View Favorites</a>',
      "</aside>",
    ].join("");
  };

  const showModal = (item) => {
    let modal = document.querySelector("[data-fadrop-wishlist-modal]");
    if (!modal) {
      modal = document.createElement("div");
      modal.className = "fadrop-wishlist-modal";
      modal.setAttribute("data-fadrop-wishlist-modal", "");
      document.body.appendChild(modal);
    }

    modal.innerHTML = modalMarkup(item);
    modal.hidden = false;
    document.documentElement.classList.add("overflow-hidden");

    const close = () => {
      modal.hidden = true;
      document.documentElement.classList.remove("overflow-hidden");
    };

    modal.querySelectorAll("[data-fadrop-wishlist-close]").forEach((button) => {
      button.addEventListener("click", close, { once: true });
    });

    window.setTimeout(() => {
      document.addEventListener("keydown", function handleEscape(event) {
        if (event.key !== "Escape") return;
        close();
        document.removeEventListener("keydown", handleEscape);
      });
    });
  };

  const bindEdit = (root) => {
    const edit = root.querySelector("[data-fadrop-wishlist-edit]");
    if (!edit || edit.dataset.fadropWishlistBound) return;

    edit.dataset.fadropWishlistBound = "true";
    edit.addEventListener("click", () => {
      const editing = !root.classList.contains("is-editing");
      root.classList.toggle("is-editing", editing);
      edit.classList.toggle("is-active", editing);
      edit.setAttribute("aria-label", editing ? "Done editing wishlist" : "Edit wishlist");
      edit.setAttribute("title", editing ? "Done editing wishlist" : "Edit wishlist");
    });
  };

  const bindViewToggle = (root) => {
    root.querySelectorAll("[data-fadrop-wishlist-view]").forEach((button) => {
      if (button.dataset.fadropWishlistBound) return;
      button.dataset.fadropWishlistBound = "true";
      button.addEventListener("click", () => setView(root, button.dataset.fadropWishlistView));
    });

    setView(root, readView());
  };

  const renderPage = async () => {
    const root = document.querySelector("[data-fadrop-wishlist-page]");
    if (!root) return;

    if (!signedIn(root)) {
      redirectToLogin(root);
      return;
    }

    const grid = root.querySelector("[data-fadrop-wishlist-grid]");
    const empty = root.querySelector("[data-fadrop-wishlist-empty]");
    const edit = root.querySelector("[data-fadrop-wishlist-edit]");
    const controls = root.querySelector("[data-fadrop-wishlist-controls]");
    const items = read();
    const currency = root.dataset.currency || "AED";

    if (!grid || !empty) return;

    empty.hidden = items.length > 0;
    grid.hidden = items.length === 0;
    if (edit) edit.hidden = items.length === 0;
    if (controls) controls.hidden = items.length === 0;
    bindViewToggle(root);

    if (!items.length) {
      grid.innerHTML = "";
      root.classList.remove("is-editing");
      if (edit) {
        edit.classList.remove("is-active");
        edit.setAttribute("aria-label", "Edit wishlist");
        edit.setAttribute("title", "Edit wishlist");
      }
      bindEdit(root);
      return;
    }

    grid.setAttribute("aria-busy", "true");
    const hydrated = await Promise.all(items.map((item) => fetchProduct(item, currency)));
    grid.innerHTML = hydrated.map(cardMarkup).join("");
    grid.removeAttribute("aria-busy");

    grid.querySelectorAll("[data-fadrop-wishlist-remove]").forEach((button) => {
      button.addEventListener("click", () => {
        remove(button.dataset.fadropWishlistRemove);
        syncAllButtons();
        renderPage();
      });
    });

    bindEdit(root);
  };

  const watchDynamicButtons = () => {
    if (dynamicButtonObserver || !document.body) return;

    dynamicButtonObserver = new MutationObserver((mutations) => {
      const hasNewWishlistButton = mutations.some((mutation) => Array.from(mutation.addedNodes).some((node) => {
        if (node.nodeType !== 1) return false;
        return node.matches?.("[data-fadrop-wishlist-button]") || node.querySelector?.("[data-fadrop-wishlist-button]");
      }));

      if (hasNewWishlistButton) bindButtons();
    });

    dynamicButtonObserver.observe(document.body, { childList: true, subtree: true });
  };

  const init = () => {
    bindButtons();
    watchDynamicButtons();
    renderPage();
    consumePending();
  };

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
  window.addEventListener("fadrop:wishlist:change", syncAllButtons);

  window.FadropWishlist = { init, read, write, remove };

  if (document.readyState !== "loading") {
    init();
  }
})();
